<template>
  <div>
    <div class="product_consult" v-if="isconsult">
      <div :class="`${index==0?'product_consult_box2':index==4?'product_consult_box3':''}`" class="product_consult_box" v-for="(item,index) in aside" :key="index" @mouseenter="goimage(index)" @mouseleave="leaveimage(index)" @click="cartoon(index)" >
        <img :src="`${number==index?item.img2:item.img1}`"  :alt=item.name>
        <p>{{item.name}}</p>
      </div>
      <div class="product_consult_phone" v-if="showphone" >
        <p>售前咨询（服务时间 9:00-24:00）</p>
        <div>
          <img src="/static/imgs/phone.svg" alt=''>
          <p class="telephone">13429685631</p>
        </div>
      </div>
      <img src="/static/imgs/gongzhong.png" alt="wechat" class="product_consult_wechat" v-if="showwechat">
    </div>
    <div class="product_mobile" v-if="isconsult2">
      <div class="product_mobile_bottom">
        <a href="tel:13429685631">
        <div class="product_mobile_content">
          <img src="/static/imgs/consult_phone.svg" alt="">
          <p>电话咨询</p>
        </div>
        </a>
        <div class="product_mobile_content product_mobile_content2" @click="showbox2">
          <img src="/static/imgs/consult_order.svg" alt="">
          <p>预约演示</p>
        </div>
      </div>
    </div>
    <div class="product_consult_ordermobile" v-if="showorder" >
      <div class="product_consult_order" v-if="success"  >
        <img src="/static/imgs/consult_close.svg" alt="" class="close" @click="close">
        <h1 class="product_consult_order_title">预约免费演示</h1>
        <div class="product_consult_order_line"></div>
        <h2 class="product_consult_order_subtitle">请留下联系方式，我们客户经理将会在一个工作日内联系您并预约具体演示的时间。</h2>
        <img src="/static/imgs/sidebanner.svg" alt="" class="product_consult_order_img">
        <div class="product_consult_content">
          <div class="product_consult_content_tel" >中国大陆+86
            </div>
          <input type="text" placeholder="请输入电话" v-model="telephone" @input="write(1)" :disabled="disabled" :style="disabled ? 'cursor:no-drop' : ''">
        </div>
        <p class="product_consult_test product_consult_test2" v-if="error">请输入正确的手机号</p>
        <div class="product_consult_content2">
          <input type="text" placeholder="请输入验证码" v-model="code" @input="write(2)">
          <div class="product_consult_content_button" v-if="showcode" @click="getcode">发送验证码</div>
          <div class="product_consult_content_button" v-else :disabled="disabled" :style="disabled ? 'cursor:no-drop' : ''">{{waittime+'s'}}</div>
        </div>
        <p class="product_consult_test"  v-if="error2">请输入正确的验证码</p>
        <input type="text" class="product_consult_input" placeholder="输入您的姓名" v-model="name" @input="write(3)">
          <p class="product_consult_test" v-if="error3">请输入您的姓名</p>
        <input type="text" class="product_consult_input" placeholder="输入公司名称" v-model="company" @input="write(4)">
        <p class="product_consult_test" v-if="error4">请输入公司名称</p>
        <div>
          <select v-model="language" class="product_consult_select" >
            <option value="zh">语言-中文</option>
            <option value="en">语言-英语</option>
          </select>
        </div>
        <div class="product_consult_bottom" @click="submit">提交</div>
      </div>
      <div class="product_consult_ordermobile" v-else>
        <div class="product_consult_success">
          <img src="/static/imgs/consult_close.svg" alt="" class="close" @click="close2">
          <h1 class="product_consult_order_title">您已成功预约</h1>
          <div class="product_consult_order_line"></div>
          <h2 class="product_consult_order_subtitle">客户经理将会在<span>1个工作日</span>内联系您并预约具体演示的时间。</h2>
          <img src="/static/imgs/success.svg" alt="" class="success_img">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name:'sidebanner',
  props:['openOrder'],
  data(){
    return {
      isconsult:'',
      isconsult2:'',
      number:10,
      showphone:false,
      showwechat:false,
      showorder:false,
      screenwidth:document.body.offsetWidth,
      aside:[
        {
          img1:'/static/imgs/zixun.svg',
          img2:'/static/imgs/zixun2.svg',
          name:'在线咨询'
        },
        {
          img1:'/static/imgs/dianhuazixun2.svg',
          img2:'/static/imgs/dianhuazixun.svg',
          name:'电话咨询'
        },
        {
          img1:'/static/imgs/weixinzixun2.svg',
          img2:'/static/imgs/weixinzixun.svg',
          name:'微信咨询'
        },
        {
          img1:'/static/imgs/zaixianyuyue2.svg',
          img2:'/static/imgs/zaixianyuyue.svg',
          name:'预约演示'
        },
        {
          img1:'/static/imgs/gotop.svg',
          img2:'/static/imgs/gotop2.svg',
          name:'回到顶部'
        },
      ],
      telephone:'',
      code:'',
      name:'',
      company:'',
      error:false,
      error2:false,
      error3:false,
      error4:false,
      waittime:'59',
      showcode:true,
      disabled:false,
      timmout:'',
      success:true,
      codery:'',
      language: 'zh'
    }
  },
  methods:{
    goimage(index){
      this.number=index
      if(index==1){
        this.showphone=true
      }else if(index==2){
        this.showwechat=true
      }
    },
    leaveimage(index){
      this.number=10
      if(index==1){
        this.showphone=false
      }else if(index==2){
        this.showwechat=false
      }
    },
    showbox2(){
      this.showorder=true
    },
    close(){
      this.error=this.error2=this.error3=this.error4=false
      this.showorder=false
      this.telephone=this.name=this.code=this.company=''
    },
    close2(){
      this.showorder=false
      this.success=true
    },
    cartoon(index){
      if(index==0){
        this.consult()
      }else if(index==4){
        let end=document.querySelector('#app').getBoundingClientRect().top
        this.scrollcartonn(end)
      }else if(index==3){
        this.showorder=true
      }
    },
    consult(){
      if (window.Tawk_API) {
        window.Tawk_API.maximize();
      }
      return
      if (window.fcWidget.isLoaded()) {
        window.fcWidget.open()
      }
    },
    scrollcartonn(end){
      let start = document.documentElement.scrollTop || document.body.scrollTop;
      let step = (end)/220;
      let d = step
      let count = 0;
      let timer =  setInterval(() => {
        if (count > 30 && count <= 70) {
          d = 3*step
        } else if (count > 10 && count <= 90) {
          d = 2*step
        } else if (count > 0 && count < 100) {
          d = step
        }
        start += d
        window.scrollTo(0, start)
        count++;
        if (count >= 100) {
          clearInterval(timer)
        }
      }, 10);
    },
    submit(){
      let index=1
      let reg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
      if(this.telephone=='' || !reg.test(this.telephone)){
        this.error=true
        index=index-1
      }
      if(this.code=='' || this.code!=this.codery){
        this.error2=true
        index=index-1
      }
      if(this.name==''){
        this.error3=true
        index=index-1
      }
      // if(this.company==''){
      //   this.error4=true
      //   index=index-1
      // }
      if(index==1){
        let params={
          "phone": this.telephone,
          "type": 1,
          "name": "天识信息科技",
          "template": `SMS_237065530`,
          "code": this.codery
        }
        this.$axios.post('https://gateway.antdiy.vip/alibaba-service/sms',params).then(res=>{

        })
        this.$axios.get(`https://gateway.antdiy.vip/website/chat/0b5c1899805ec43213876bc1ce2a703b5f2758a1f7052c316fd8a00459e420aa`,{
          params:{
            message: `客户需要预约演示，请售前尽快联系安排！\n客户电话：${this.telephone}\n客户姓名：${this.name}\n公司名称：${this.company}\n客户语言:${this.language==='en' ? '英语': '中文'}`
          }
        }).then(res=>{
           this.success=false
           this.telephone=this.name=this.code=this.company=''
        })
      }

    },
    write(index){
      if(index==1){
        this.error=false
      }else if(index==2){
        this.error2=false
      }else if(index==3){
        this.error3=false
      }else if(index==4){
        this.error4=false
      }
    },
    getcode(){
      let reg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
      if(this.telephone=='' || !reg.test(this.telephone)){
        this.error=true
        return
      }
      this.showcode=false
      this.count()
      this.disabled=true
      let params={
        "phone": this.telephone,
        "type": 1,
        "name": "天识信息科技",
        "template": `SMS_237060511`,
        "code": this.codery
      }
      this.$axios.post('https://gateway.antdiy.vip/alibaba-service/sms',params).then(res=>{
      })
    },
    count() {
      let siv = setInterval(() => {
        this.waittime--;
        if (this.waittime <= -1) {
          clearInterval(siv);
          this.waittime = 59;
          this.showcode=true;
          this.disabled=false
        }
      }, 1000);
    },
  },
  created(){
    let code= Math.floor(Math.random()*900000+100000)
    localStorage.setItem('code',code)
    this.codery=localStorage.getItem('code')
    if (document.body.offsetWidth > 767) {
      this.isconsult = true
    } else {
      this.isconsult = false
      this.isconsult2=true
    }
    const that=this
    // 监听窗口的变化,由于screenwidth只有初始设置为屏幕宽度,改变屏幕大小时并没有主动变化,watch检测不到,所以需要加一个监听窗口大小的方法,然后持续给screenwidth赋值,这样watch就监听到了
    window.onresize=()=>{
      return (()=>{
        window.screenWidth=document.body.offsetWidth
        that.screenwidth=window.screenWidth
      })()
    }
  },
  watch:{
    screenwidth:{
      immediate:true,
      handler:function(value){
        if(value>990){
          this.isconsult = true
        } else {
          this.isconsult = false
        }
      }
    },
    openOrder(newD, oldD) {
      if (newD) {
        this.showorder = newD;
      }
    }
  },
}
</script>

<style scoped>
 .product_consult_ordermobile{
    width: 100%;
    background: rgba(0,0,0,.5);
    z-index: 999;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
.product_consult_success{
  width: 568px;
  height: auto;
  background: #FFFFFF;
  box-shadow: 0px 2px 15px 0px rgba(221,221,221,0.43);
  border-radius: 20px;
  position: absolute;
  top:50%;
  left: 50%;
  transform: translate(-50%,-50%);
  z-index:1000;
  padding: 40px 80px 60px;
}
.success_img{
  width: 274px;
  height: 294px;
  display: block;
  margin: 45px auto 0;
}
.product_consult{
  width: 84px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.12);
  border-radius: 10px;
  position: fixed;
  right: 14px;
  bottom:90px;
  z-index: 999;
}
.close{
  position: absolute;
  right: 60px;
  top:28px;
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.product_consult_box{
  width: 84px;
  height: 76px;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
}
.product_consult_box2{
  border-radius: 10px 10px 0 0;
}
.product_consult_box3{
  border-radius: 0 0 10px 10px;
}
.product_consult_phone{
  width: 208px;
  height: 76px;
  background: #FFFFFF;
  box-shadow: 0px 2px 6px 0px rgba(189,189,189,0.5);
  border-radius: 4px;
  padding: 15px 0 15px 10.5px;
  position: absolute;
  top: 76px;
  right: 90px;
}
.product_consult_phone p{
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  color: #222536;
  letter-spacing: 0;
  font-weight: 400;
}
.telephone{
  font-size: 15px!important;
}
.product_consult_phone div{
  display: flex;
  margin-top: 14px;
  align-items: center;
}
.product_consult_phone img{
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
.product_consult_wechat{
  width: 104px;
  height: 104px;
  position: absolute;
  top: 152px;
  right: 90px;
}
.product_consult_box:hover{
  background: #FB5422;
  color: #ffffff;
}
.product_consult_box img{
  margin-bottom: 8px;
}
.product_consult_order{
  width: 568px;
  max-height: 95vh;
  overflow: auto;
  background: #FFFFFF;
  box-shadow: 0px 2px 15px 0px rgba(221,221,221,0.43);
  border-radius: 10px;
  padding: 40px 60px 62px;
  position: absolute;
  top:50%;
  left: 50%;
  transform: translate(-50%,-50%);
  z-index:1000
}
.product_consult_order_title{
  font-family: SourceHanSansCN-Bold;
  font-size: 36px;
  color: #222536;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: 700;
}
.product_consult_order_line{
  width: 60px;
  height: 8px;
  background: #FC5421;
  border-radius: 6px;
  margin: 24px auto 26px;
}
.product_consult_order_subtitle{
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  color: #222536;
  letter-spacing: 0.25px;
  text-align: center;
  line-height: 26px;
  font-weight: 500;
}
.product_consult_order_subtitle span{
  color: #FB2F31;
}
.product_consult_order_img{
  width: 100%;
  margin: 30px 0;
}
.product_consult_content{
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  position: relative;
}
.product_consult_content_tel{
  width: 149px;
  height: 50px;
  background-image: linear-gradient(180deg, #FFFFFF 0%, #E5E5E5 100%);
  border: 1px solid rgba(151,151,151,0.5);
  border-radius: 8px 0px 0px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #4C4C4C;
  font-weight: 400;
  cursor:pointer
}
.product_consult_content_tel img{
  width: 12px;
  height: 12px;
  margin-left: 9.4px;
}
.product_consult_content input{
  width: 300px;
  height: 50px;
  border: 1px solid rgba(151,151,151,0.5);
  border-radius: 0 8px 8px 0;
}
/* .product_consult_content, */
.product_consult_content2,
.product_consult_input,
.product_consult_select{
  margin-top: 18px;
}
.product_consult_select {
  outline: none;
  appearance: none;
  /*在选择框的最右侧中间显示小箭头图片*/
  background: url(../../assets/pull_down.svg) no-repeat scroll 96% center transparent;
  color: rgba(151,151,151,0.5) !important;
}
.product_consult_select:hover {
  border: 1px solid rgba(252,83,34,1);
}
.product_consult_select::-ms-expand {
  display: none;
}
.product_consult_content2{
  display: flex;
  align-items: center;
}
.product_consult_content2 input{
  width: 300px;
  height: 50px;
  margin-right: 20.6px;
  border: 1px solid rgba(151,151,151,0.5);
  border-radius: 8px;
}
.product_consult_content_button{
  width: 129px;
  height: 50px;
  background: #FC5322;
  box-shadow: 0px 6px 8px 0px rgba(252,83,34,0.1);
  border-radius: 4px;
  font-family: SourceHanSansCN-Medium;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: 500;
  line-height: 50px;
  cursor:pointer
}
.product_consult_input,
.product_consult_select{
  width:100% ;
  height: 50px;
  border: 1px solid rgba(151,151,151,0.5);
  border-radius: 8px;
}
.product_consult_bottom{
  width: 100%;
  height: 50px;
  background: #FC5322;
  box-shadow: 0px 6px 8px 0px rgba(252,83,34,0.1);
  border-radius: 4px;
  font-family: SourceHanSansCN-Medium;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: 500;
  line-height: 50px;
  margin-top: 40px;
  cursor:pointer
}
input, .product_consult_select{
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: rgba(0,0,0);
  font-weight: 400;
  padding-left: 18px;
}
input::-webkit-input-placeholder{
  color: rgba(0,0,0,0.28);
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
  color: rgba(0,0,0,0.28);
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
  color: rgba(0,0,0,0.28);
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
  color: rgba(0,0,0,0.28);
}
input:hover{
  border: 1px solid rgba(252,83,34,1);
}
.product_consult_test{
  font-size: 14px;
  color: #ff3530;
  margin-top: 5px;
}
@media (max-width:767px){
  .product_mobile_bottom{
    display: flex;
    position: fixed;
    bottom: 23px;
    left: .48rem;
    z-index: 10;
  }
  .product_mobile_content2{
    margin-left: .12rem;
  }
  .product_mobile_content{
    width: 1.58rem;
    height: 1.07rem;
    background: #FFDDD3;
    box-shadow: 0 5px 4px 0 rgb(0 0 0 / 26%);
    border-radius: .04rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .product_mobile_content img{
    width: .24rem;
    height: .24rem;
  }
  .product_mobile_content p{
    font-family: SourceHanSansCN-Regular;
    font-size: .24rem;
    color: #222536;
    letter-spacing: 0.0033rem;
    font-weight: 400;
    margin-top: .12rem;
  }
  .product_consult_ordermobile{
    width: 100%;
    background: rgba(0,0,0,.5);
    z-index: 999;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
  .product_consult_order{
    width: 100%;
    max-height: 80vh;
    overflow: auto;
    box-shadow: none;
    border-radius: .1rem;
    padding: .55rem .7rem .7rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .product_consult_order_title{
    font-size: .4rem;
    letter-spacing: 0.005rem;
  }
  .product_consult_order_line{
    width: .6rem;
    height: .08rem;
    border-radius: .6rem;
    margin: .29rem auto .3rem;
  }
  .product_consult_order_subtitle{
    font-size: .24rem;
    letter-spacing: 0.0033rem;
    line-height: .32rem;
  }
  .product_consult_order_img{
    margin: .25rem 0 .3rem;
  }
  .product_consult_content{
    height: .56rem;
  }
  .product_consult_content_tel{
    width: 1.61rem;
    height: .56rem;
    border-radius: .08rem 0px 0px .08rem;
    font-size: .18rem;
  }
  /* .product_consult_content_tel img{
    width: 12px;
    height: 12px;
    margin-left: 9.4px;
  } */
  .product_consult_content input{
    width: 4.49rem;
    height: .56rem;
    border: 1px solid rgba(151,151,151,0.5);
    border-radius: 0 .08rem .08rem 0;
  }
  /* .product_consult_content, */
  .product_consult_content2,
  .product_consult_input,
  .product_consult_select{
    margin-top: .23rem;
  }
  .product_consult_content2 input{
    width: 4.32rem;
    height: .56rem;
    margin-right: .256rem;
    border-radius: .08rem;
  }
  .product_consult_content_button{
    width: 1.52rem;
    height: .56rem;
    box-shadow: 0px .06rem .08rem 0px rgba(252,83,34,0.1);
    border-radius: .04rem;
    font-size: .18rem;
    letter-spacing: 0.0056rem;
    line-height: .56rem;
  }
  .product_consult_input,
  .product_consult_select{
    height: .56rem;
    border-radius: .08rem;
  }
  .product_consult_bottom{
    height: .56rem;
    box-shadow: 0px .06rem .08rem 0px rgba(252,83,34,0.1);
    border-radius: .04rem;
    font-size: .24rem;
    letter-spacing: 0.0075rem;
    line-height: .56rem;
    margin-top: .45rem;
  }
  input, .product_consult_select{
    font-size: .18rem;
    padding-left: .18rem;
  }
  .product_consult_test{
    font-size: .14rem;
    margin-top: .05rem;
  }
  .close{
    right: .7rem;
    top:.28rem;
    width: .4rem;
    height: .4rem;
  }
  .product_consult_success{
    width: 5.68rem;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px .02rem .15rem 0px rgba(221,221,221,0.43);
    border-radius: .2rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    padding: .4rem .8rem .6rem;
  }
  .success_img{
    width: 2.74rem;
    height: 2.94rem;
    display: block;
    margin: .45rem auto 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/sidebanner.vue